module.exports = __webpack_public_path__ + "img/cp_img1.159a22f7.png";